import React, { useState } from 'react';
import { TrendingDown } from 'lucide-react';
import { InfoBox, InputGroup } from '../Common';

const SortinoTool = () => {
    const [pr, setPr] = useState(24);
    const [rfr, setRfr] = useState(6);
    const [dd, setDd] = useState(9);

    const so = dd > 0 ? (pr - rfr) / dd : 0;

    return (
        <div className="tct-tool-container">
            <div className="tct-panel-title">Sortino Ratio</div>
            <div className="tct-input-wrap d-flex flex-wrap gap-2">
                <InputGroup label="Port. Return %" value={pr} onChange={setPr} />
                <InputGroup label="Risk Free %" value={rfr} onChange={setRfr} />
                <InputGroup label="Downside Dev %" value={dd} onChange={setDd} />
            </div>
            <div className="tct-results-grid mt-4">
                <div className="tct-card tct-blue">
                    <div className="tct-data-row"><span className="tct-label">Sortino Ratio</span><span className="tct-value val-blue big-value">{so.toFixed(2)}</span></div>
                </div>
            </div>
            <InfoBox
                title="Sortino Ratio: A Better Risk Metric for Traders"
                meta="Sortino ratio focuses on downside volatility instead of total volatility"
                sections={[
                { title: "Introduction", content: "Sortino ratio improves Sharpe ratio by penalizing only negative volatility.<br><br>This provides a more accurate picture of strategy risk." }

                ]}
            />
        </div>
    );
};

export default SortinoTool;
